import ReactJsonView from "@microlink/react-json-view"
import { Button } from "react-bootstrap"

export default function JSONData(
    props: {
        data: any
        maxHeight?: string
        fontSize?: string
        title?: string
        indentWidth?: number
        // true collapses everything; a number collapses nodes deeper than that level
        collapsed?: boolean | number
        onClose?: () => void
        onAdd?: () => void
        onDelete?: () => void
        onEdit?: () => void
    }
) {
    const { 
        data, 
        maxHeight = '400px', 
        fontSize = '12px', 
        title, 
        indentWidth = 4, 
        collapsed = false,
        onClose,
        onAdd,
        onDelete,
        onEdit
    } = props

    return (
        <div style={{ position: 'relative', border: '1px solid #dee2e6', borderRadius: '5px', padding: '10px' }}>
            {(title || onClose) && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                    {title && <strong>{title}</strong>}
                    {onClose && (
                        <Button
                            size="sm"
                            onClick={onClose}
                            variant="danger"
                        >
                            &times;
                        </Button>
                    )}
                </div>
            )}
            <ReactJsonView
                src={data}
                name={false}
                collapsed={collapsed}
                theme="summerfruit:inverted"
                // iconStyle="square"
                enableClipboard={false}
                displayDataTypes={false}
                style={{ 
                    maxHeight, 
                    overflowY: 'auto',
                    fontSize,
                    tabSize: indentWidth,
                }}
                sortKeys={true}
                showComma={false}
                quotesOnKeys={false}
                indentWidth={indentWidth}
                onAdd={onAdd}
                onDelete={onDelete}
                onEdit={onEdit}
            />
        </div>
    )
}
